import { Dayjs } from 'dayjs';

export const getEndDateForAgreementLength = (startDate: Dayjs, days: number) =>
  startDate
    .clone()
    .add(days - 1, 'days')
    .format('YYYY-MM-DD');
